import ErrorBoundary from './components/common/ErrorBoundary';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Global patch to prevent React 18/19 crashes when browser translation (Google Translate) is used.
// Google Translate injects <font> tags and mutates text nodes directly in the DOM.
// When React tries to remove or reorder nodes during reconciliation (search, filter, pagination),
// standard removeChild/insertBefore throws NotFoundError because parentNode was altered by Translate.
if (typeof window !== 'undefined' && typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child && child.parentNode !== this) {
      if (child.parentNode) {
        return child.parentNode.removeChild(child);
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (referenceNode.parentNode) {
        return referenceNode.parentNode.insertBefore(newNode, referenceNode);
      }
      return originalInsertBefore.call(this, newNode, null);
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
